<template>
  <div>
    <top></top>
    <navMenu></navMenu>
    <div class="inner">
      <!-- <Header></Header> -->
      <!-- <nav-img></nav-img> -->
      <navbar></navbar>
      <div class="main">
        <div class="banner">
          <aside-left class="aside_left"></aside-left>
          <div class="news_main">
            <div class="fabiao" v-show="isshow">
              <fabiao-news @renoav="getrenova"></fabiao-news>
              <div class="biao" v-show="isshare">
                <biao @renoav="getrenova"></biao>
              </div>
              <div class="glass">
                <glass @spaceid="apr" :title="this.title"></glass>
              </div>
            </div>

            <div v-if="shuoshow">
              <news-main :list="DynamicList" @renoav="getrenova"></news-main>
            </div>
            <div v-else>
              <Zanwu></Zanwu>
            </div>
          </div>
          <advertising class="aside_left_two"></advertising>
        </div>
      </div>
      <div class="dingbu">
        <scroll-top></scroll-top>
      </div>
    </div>
  </div>
</template>

<script>
import top from "@/components/common/top.vue";
import navMenu from "@/components/common/navMenu.vue";
import URL from "../../api/index";
// 引入主导航栏区域
import Header from "../../components/space/Header";
// 引入主体背景区域
import NavImg from "../../components/space/NavImg";
// 引入导航栏区域
import Navbar from "../../components/space/Navbar";
// 引入侧边栏区域
import AsideLeft from "../../components/space/Aside";
import Advertising from "../../components/space/advertising";
// 引入发表最新动态框
import FabiaoNews from "../../components/space/FabiaoNews";
// 引入右侧主体区域
import NewsMain from "../../components/space/NewsMain";
// 引入返回顶部按钮
import scrollTop from "../..//components/space/scrollTop";
//暂无数据
import Zanwu from "../../components/common/zanwu";
//  表情包
import Biao from "../../components/space/biaoqing";
// 班级圈
import Glass from "../../components/space/Glass_qh";
import axios from "axios";
export default {
  data() {
    return {
      NewDynamicList: "",
      DynamicList: "",
      UserInfo: "",
      iteminfo: "",
      getSpaceinfo: "",
      shuoshow: true,
      pagenum: "10",
      isshare: false,
      spaceid: "",
      isshow: true,
      spacelist: "",
      title: "",
      isstart: "start",
    };
  },
  components: {
    top,
    navMenu,
    Header,
    NavImg,
    Navbar,
    AsideLeft,
    NewsMain,
    FabiaoNews,
    Advertising,
    scrollTop,
    Zanwu,
    Biao,
    Glass,
  },
  mounted() {
    this.getRecordRjw(JSON.parse(localStorage.getItem("loginInfo")));
    this.UserInfo = JSON.parse(window.localStorage.getItem("info"));
    this.user();
  },
  methods: {
    user() {
      var userspace = {
        token: this.UserInfo.token,
        user_id: this.UserInfo.user_id,
      };
      this.$post(URL.userspace, userspace).then((res) => {
        var newArray = [];
        var j = 0;
        for (var i = 0; i < res.result.length; i++) {
          if (res.result[i].space_type == "0104") {
            newArray[j++] = res.result[i];
          }
        }
        this.cities = newArray;
        this.checkedCities = this.cities[0];
        this.spacelist = this.cities[0].space_id;
        this.getDynamic(this.pagenum, this.spacelist);
      });
    },
    getrenova(val) {
      if (val == true) {
        this.isshare = true;
      } else if (val == false) {
        this.isshare = false;
      } else {
        var userspace = {
          token: this.UserInfo.token,
          user_id: this.UserInfo.user_id,
        };
        this.$post(URL.userspace, userspace).then((res) => {
          var newArray = [];
          var j = 0;
          for (var i = 0; i < res.result.length; i++) {
            if (res.result[i].space_type == "0104") {
              newArray[j++] = res.result[i];
            }
          }
          this.cities = newArray;
          this.checkedCities = this.cities[0];
          this.spacelist = this.cities[0].space_id;
          this.getDynamic(val, this.spacelist);
        });
      }
    },
    apr(val) {
      // console.log(val);
      this.spacelist = val;
      this.getDynamic(this.pagenum, this.spacelist);
    },
    getDynamic(e, d) {
      var that = this;
      var gerdynamicdata = {
        token: that.UserInfo.token,
        spaceid: d,
        pagenum: e,
      };
      this.$post(URL.getDynamiclist, gerdynamicdata).then((res) => {
        var listt = res.result.dynamic_list;
        this.title = listt[0].space_name;
        listt.forEach((element) => {
          if (element.dynamic_wmm !== "") {
            element.dynamic_wmm = JSON.parse(element.dynamic_wmm)["pic"];
          }
          that.DynamicList = listt;
        });
        if (that.DynamicList.length > 0) {
          that.shuoshow = true;
        } else {
          that.shuoshow = false;
        }
      });
    },
    //上报数据
    getRecordRjw(hh) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_classring",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的班级圈",
          data: {
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  padding-top: 20px;
}
.main {
  background-color: #f5f6f8;
  // min-height: 1000px;
  .banner {
    padding: 25px 0;
    margin: 0 auto;
    width: 1200px;
    overflow: hidden;
    .aside_left {
      float: left;
    }
    .shoucang_main {
      float: right;
      width: 877px;
    }
  }
  .aside_left_two {
    float: left;
    clear: left;
  }
}
.news_main {
  float: right;
  width: 877px;
}
.dingbu {
  position: fixed;
  bottom: 30px;
  right: 30px;
}
.fabiao {
  position: relative;
  .glass {
    position: absolute;
    bottom: 10px;
    left: 0;
  }
}
.biao {
  width: 390px;
  background-color: #fff;
  position: absolute;
  top: 70%;
  left: -56%;
  z-index: 3;
}
</style>
